module.exports = __webpack_public_path__ + "static/media/forwar_arrow_profile.b01c0688.svg";